import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LoginPage from './pages/profile/loginPage';
import RegisterPage from './pages/profile/registerPage';
import ForgotPasswordPage from './pages/profile/ForgotPasswordPage';
import CalendarPage from './pages/home/calendarPage';
import ProfilePage from './pages/profile/profilePage';
import AdminPage from './pages/admin/adminPage';
import PrivateRoute from './components/privateRoute';
import PrivacyPolicy from './pages/privacyPolicy';
import Layout from './components/layout';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />, // Layout est utilisé comme wrapper ici
      children: [
        {
          path: "/",
          element: user ? <PrivateRoute><CalendarPage /></PrivateRoute> : <LoginPage />,
        },
        {
          path: "login",
          element: <LoginPage />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPasswordPage />,
        },
        {
          path: "/register",
          element: <RegisterPage />,
        },
        {
          path: "profile",
          element: user ? <PrivateRoute><ProfilePage /></PrivateRoute> : <LoginPage />,
        },
        {
          path: "/admin",
          element: user ? <PrivateRoute><AdminPage /></PrivateRoute> : <LoginPage />,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicy />,
        },
      ],
    },
  ]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <RouterProvider router={router} />
  );
}

export default App;
